import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors, breakpoints } from 'app/variables';
import { ResmioIcon } from 'app/commonComponents/icons';
import CookieConsent from 'app/components/cookieConsent';

import LegalFooter from './LegalFooter';

const Container = styled.div`
  background-color: ${colors.white};
  display: flex;
  min-height: 100vh;
`;

const Sidebar = styled.aside`
  display: none;

  @media (min-width: ${breakpoints.desktop}) {
    align-items: center;
    background: linear-gradient(${colors.pacificBlue}, ${colors.white} 100vh);
    display: flex;
    flex-direction: column;
    width: 38.2%;
  }
`;

const SidebarContent = styled.div`
  justify-content: center;
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 80%;

  & h1 {
    font-size: 2.6rem;
    margin: -1rem 0 2rem;
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const MainHeader = styled.div`
  padding: 2rem;
  text-align: center;

  @media (min-width: ${breakpoints.desktop}) {
    text-align: right;
  }
`;

const MainMobileHeader = styled.div`
  background: linear-gradient(
    ${colors.pacificBlue},
    ${colors.white} calc(100% - 1rem)
  );
  text-align: center;

  @media (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`;

const MainContent = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const MainContentWrapper = styled.div`
  max-width: ${breakpoints.medium};
  padding: 2rem;
  width: 100%;
`;

const MainFooter = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`;

function Layout({ children, header, sidebar }) {
  return (
    <Container>
      <Sidebar>
        <SidebarContent>
          <ResmioIcon
            style={{
              fill: colors.white,
              margin: 0,
              strokeWidth: 0,
              width: '256px',
            }}
          />
          <div style={{ margin: '0 0 0 95px' }}>
            <h1>
              {i18n.gettext('The management solution for your restaurant')}
            </h1>
            {sidebar}
          </div>
        </SidebarContent>
        <LegalFooter />
      </Sidebar>
      <Main>
        <MainMobileHeader>
          <ResmioIcon
            style={{
              fill: colors.white,
              height: '90px',
              margin: '2rem auto 4rem',
              strokeWidth: 0,
            }}
          />
        </MainMobileHeader>
        <MainHeader>{header}</MainHeader>
        <MainContent>
          <MainContentWrapper>{children}</MainContentWrapper>
        </MainContent>
        <MainFooter>
          <LegalFooter />
        </MainFooter>
      </Main>
      <CookieConsent fromApp />
    </Container>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  sidebar: PropTypes.node,
};

export default Layout;
